<template>
  <div class="container bottom-fix-padding">
    <v-datepicker v-show="ifDatePick" outer_opendate="1" :outer_disableddates="pick_disabledDate" :outer_date="order.data.pick_date" :outer_period="order.data.pick_period" @change="pickDateSave" @close="pickDateClose()" ></v-datepicker>
    <v-datepicker v-show="ifDateReturn" outer_opendate="0" :outer_disableddates="return_disabledDate" outer_initView="month" :outer_date="order.data.return_date" :outer_period="order.data.return_period" @change="returnDateSave" @close="returnDateClose()"></v-datepicker>
    <div class="core" v-show="!ifDatePick&&!ifDateReturn">
      <div class="navi">
          <span class="icon-arrow-left" @click="goto('/warehouse-step1')"></span>
      </div>
      <div class="title">仓储寄存详情</div>

      <div class="main">
          <div class="core">
            <div class="weui-cells__title">联系信息</div>
            <div class="weui-cells weui-cells_form">
                <div class="weui-cell">
                    <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="text" placeholder="请输入您的名字" v-model="order.data.username" >
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label class="weui-label">联系手机</label>
                    </div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="tel" placeholder="请输入您的手机号" v-model="order.data.userphone">
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd"><label class="weui-label">备用联系</label></div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="text" placeholder="微信号 / 中国手机号" v-model="order.data.contact_bak">
                    </div>
                </div>
            </div>

            <div class="weui-cells__title">取货详情</div>
            <div class="weui-cells">
              <a class="weui-cell weui-cell_access" href="javascript:;"  @click="pickDateOpen()">
                  <div class="weui-cell__bd">
                      <p>取货日期</p>
                  </div>
                  <div class="weui-cell__ft" v-if="!order.data.pick_date">点击选择</div>
                  <div class="weui-cell__ft" v-else>{{order.data.pick_date | moment("YYYY年M月D日")}} {{pick_period}}</div>
              </a>
            </div>
            <div class="weui-cells__title">送回详情</div>

            <div class="weui-cells weui-cells_checkbox" >
                <label class="weui-cell weui-check__label" for="s12">
                    <div class="weui-cell__hd">
                        <input type="radio" name="checkbox1" class="weui-check" id="s12" value="0" v-model="order.data.return_time_pending">
                        <i class="weui-icon-checked"></i>
                    </div>
                    <div class="weui-cell__bd">
                        <p>我已经确定好了取回日期</p>
                    </div>
                </label>
                <label class="weui-cell weui-check__label" for="s11">
                    <div class="weui-cell__hd">
                        <input type="radio" class="weui-check" name="checkbox1" id="s11" value="1" v-model="order.data.return_time_pending">
                        <i class="weui-icon-checked"></i>
                    </div>
                    <div class="weui-cell__bd">
                        <p>暂时没确定取回日期</p>
                    </div>
                </label>
            </div>
            <div class="weui-cells" v-show="order.data.return_time_pending=='0'">
              <a class="weui-cell weui-cell_access" href="javascript:;" @click="returnDateOpen()">
                  <div class="weui-cell__bd">
                      <p>送回日期</p>
                  </div>
                  <div class="weui-cell__ft" v-if="!order.data.return_date">点击选择</div>
                  <div class="weui-cell__ft" v-else>{{order.data.return_date | moment("YYYY年M月D日")}} {{return_period}}</div>
              </a>
              <div class="weui-cell" v-show="weeks>0">
                  <div class="weui-cell__bd">
                      <p>存储计费时长</p>
                  </div>
                  <div class="weui-cell__ft">{{weeks}}周</div>
              </div>
            </div>

            <div class="weui-cells"  v-show="order.data.return_time_pending=='1'">
                <div class="weui-cell">
                    <div class="weui-cell__bd">
                        <p>预计存储时长（周）</p>
                    </div>
                    <div class="weui-cell__ft">
                      <v-counter @plus="plus" @minus="minus" :num='order.data.estimated_week' ></v-counter>
                    </div>
                </div>
            </div>
            <div class="weui-cells" v-show="estimated_fee>0">
                <div class="weui-cell">
                    <div class="weui-cell__bd">
                        <p>预计存储费用</p>
                    </div>
                    <div class="weui-cell__ft">
                      {{estimated_fee}}
                    </div>
                </div>
            </div>
           <div class="notice-box" v-show="weeks<=0 && order.data.return_time_pending==0">
                <div class="notice-yellow">
                    送回日期不能在取货日期之前，请检查修改
                </div>
            </div>
        </div>

      </div>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}" >下一步</div>
        </div>
      </div>

    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <div v-show="isCheckPhone">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">信息确认</strong></div>
            <div class="weui-dialog__bd">请仔细检查手机号是否正确<div class="check-phone">{{order.data.userphone}}</div></div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="isCheckPhone = false">返回修改</a>
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="orderUpdateAll('/warehouse-step3')">确认正确</a>
            </div>
        </div>
    </div>
    <img :src="pixelURL('cangchu','step3')" class="hide">
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'step3',
  data () {
    return {
      order:{
        service:'warehouse',
        data:{
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:'',
          timeTable:{}
        },
      },
      pick_disabledDate: {
        to: new Date(),
        ranges: [
            { // 禁止12-24 到 01-01选项
              from: new Date(2022, 11, 24),
              to: new Date(2023, 0, 2)
            }
        ],
      },
      return_disabledDate: {
        to: new Date(),
      },
      ifDatePick:false,
      ifDateReturn:false,
      ifUpgradePlan:false,
      localError:[],
      localErrorShow:false,
      isCheckPhone:false
    }
  },
  created: function () {
    document.querySelector("html").classList.add("grey-background");
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "warehouse"){
        this.order = localParsed;
      }
      else{
        // this.$router.push('/');
      }
    }
    else{
      // this.$router.push('/');
    }
    if(this.order.data.username==""&&localStorage.member_name){
        this.order.data.username = localStorage.member_name;
    }
    if(this.order.data.userphone==""&&localStorage.member_phone){
        this.order.data.userphone = localStorage.member_phone;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  computed: {
    pick_period: function () {
      let result = '';
      switch (this.order.data.pick_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    return_period: function () {
      let result = '';
      switch (this.order.data.return_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    weeks: function(){
      let dreturn = new Date(this.order.data.return_date);
      dreturn.setHours(0,0,0,0);

      let dpick = new Date(this.order.data.pick_date);
      dpick.setHours(0,0,0,0);

      let weekRaw = Vue.filter('duration')(dreturn-dpick,"asWeeks");
      return Math.ceil(weekRaw);
    },
    estimated_fee: function(){
      let week_price = '';
      let result = '';
      switch (this.order.data.storage_scale) {
        case "1":
          week_price = '50'
          break;
        case "2":
          week_price = '60'
          break;
        case "3":
          week_price = '70'
          break;
        default:
          console.log("1");
      }
      if(this.order.data.return_time_pending == '0'){
        result = week_price * this.weeks;
      }
      if(this.order.data.return_time_pending == '1'){
        result = week_price * this.order.data.estimated_week;
      }
      return result;
    }
  },
  methods: {
    allFilled(){
       if(this.order.data.username &&
          this.order.data.userphone &&
          this.order.data.pick_date){
            return true;
        }
    },
    checkSubmit(){
      this.localError = [];
      if (!this.order.data.username) {
        this.localError.push("请填写联系人名称");
      } else if (this.order.data.username.length>16) {
        this.localError.push("联系人名称过长，请填写16位以下字符长度的名称");
      }
      if (!this.order.data.userphone) {
        this.localError.push("请填写联系手机");
      } else if (this.order.data.userphone.length>11 || this.order.data.userphone.length<9) {
        this.localError.push("手机号码长度不正确，请检查是否正确");
      }
      if (!this.order.data.pick_date) {
        this.localError.push("请选择取货时间");
      }
      if (!this.order.data.return_time_pending) {
        this.localError.push("请填写送回详情");
      }
      if (this.order.data.return_time_pending=='0' && !this.order.data.return_date) {
        this.localError.push("请选择送回时间");
      }
      if(this.weeks<=0 && this.order.data.return_time_pending=='0'){
        this.localError.push("送回日期不能在取货日期之前，请检查修改");
      }
      if (!this.localError.length) {
        if(this.order.data.return_time_pending=='0'){
          this.order.data.cal_week=this.weeks;
        }
        if(this.checkLogin()){
            this.orderUpdateAll('/warehouse-step3');
        }
        else{
            this.isCheckPhone = true;
        }
      }
      else{
        this.localErrorShow = true;
        return false;
      }
    },
    plus(){
      this.order.data.estimated_week = this.order.data.estimated_week + 1;
      if(this.order.data.estimated_week>105){
        this.order.data.estimated_week = 105;
      }
    },
    minus(){
      this.order.data.estimated_week = this.order.data.estimated_week - 1;
      if(this.order.data.estimated_week<12){
        this.order.data.estimated_week = 12;
      }
    },

    pickDateClose(){
      this.ifDatePick = false;
      document.querySelector("html").classList.add("grey-background");
    },
    returnDateClose(){
      this.ifDateReturn = false;
      document.querySelector("html").classList.add("grey-background");
    },
    pickDateOpen(){
      this.ifDatePick = true;
      document.querySelector("html").classList.remove("grey-background");
    },
    returnDateOpen(){
      this.ifDateReturn = true;
      document.querySelector("html").classList.remove("grey-background");
    },
    pickDateSave(date,period){
      this.pickDateClose();
      this.order.data.pick_date = date;
      this.order.data.pick_period = period;
    },
    returnDateSave(date,period){
      this.returnDateClose();
      this.order.data.return_date = date;
      this.order.data.return_period= period;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.hr{
  border-top:1px solid #eee;
  margin:16pt 0;
}
.address-empty{
  color:#ccc;
  font-size:1.2em;
}

.address-detail{
  color:#666;
  font-size:1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address-parking{
  color:#aaa;
  font-size:1em;
}

.arrow-right{
  color:#ddd;
}
.move-title{
  font-weight:bold;
  font-size:1.2em;
  color:#555;
  margin-bottom:4pt;
}

.waypoint{
  font-weight:bold;
  font-size:1.2em;
  color:#777;
  margin-bottom:4pt;
}

select{
  -webkit-appearance: none;
  border: 0;
  outline: 0;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  height: 45px;
  line-height: 45px;
  position: relative;
  z-index: 1;
}

.fade-enter-active{
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
}

.more-detail{
  text-align:center;
  margin-bottom:20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/warehouse/step2.vue